// extracted by mini-css-extract-plugin
module.exports = {"title":"PhoneValidator_title__Dhf0n","par":"PhoneValidator_par__2KZNZ"};